import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from 'ng2-bootstrap-modal';
import 'rxjs/add/operator/switchMap';
import { UtilsService } from '../services/utils.service';

export interface ParserLimitationInfoModalModel {
  title: string;
  data: any;
}

@Component({
  selector: 'app-parser-limitation-info-modal',
  templateUrl: './parser-limitation-info-modal.component.html',
  styleUrls: ['./parser-limitation-info-modal.component.css']
})
export class ParserLimitationInfoModalComponent extends DialogComponent<ParserLimitationInfoModalModel, boolean> implements OnInit {
  title: string;
  data: any;
  currentLang: string;
  
  constructor(dialogService: DialogService, private utilsService: UtilsService) {
    super(dialogService);
  }

  ngOnInit() {
  	this.currentLang = localStorage.getItem('lang') || 'en';
    setTimeout(function () {
            document.getElementsByTagName('body')[0].classList.add('modal-open');
    }, 310);
    if (this.data.message) {
        this.data.message = this.utilsService.decodeHtml(this.data.message);
    } else {
        this.data.message = 'There was an unexpected error.'
            + ' Please try again or contact <a href="mailto:support@openlm.com">support@openlm.com</a> if error persists.';
    }
  }
  
  closeModal() { 
      this.result = true;
	  this.close();
  }

}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/custom-modals/parser-limitation-info-modal.component.ts